import { all, fork } from 'redux-saga/effects'
import apiKeys from './api-keys-saga'

export default function* integrations() {
  yield all([fork(apiKeys)])
}
